import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ModalController } from '@ionic/angular';
import { GeneralService } from 'src/app/services/general.service';

@Component({
  selector: 'app-confirm-input',
  templateUrl: './confirm-input.page.html',
  styleUrls: ['./confirm-input.page.scss'],
})
export class ConfirmInputPage implements OnInit {


  @Input() title = ''
  @Input() description: string = ''
  @Input() confirmText = 'Confirm'
  @Input() cancelText = 'Cancel'
  @Input() backgroundColor = 'white'
  @Input() showConfirmButton = true
  @Input() showCancelButton = true
  @Input() max_width = '330px'
  @Input() value = ''
  @Input() isValueRequired = false
  @Input() titleInput = 'Please provide the estimated amount'
  @Input() placeholderInput = '1,000'
  @Input() prefixInput = 'RM'
  @Input() maskInput = 'separator.2'
  @Input() thousandSeperatorInput = ','


  validator = {

  }

  safeDescription: SafeHtml | null = null

  constructor(
    private sanitizer: DomSanitizer,
    private modalCtrl: ModalController,
    protected generalService: GeneralService
  ) {


    // this.description = this.sanitizer.bypassSecurityTrustHtml(this.description);
    // console.log(this.description)
  }

  ngOnInit() {
    this.safeDescription = this.sanitizer.bypassSecurityTrustHtml(this.description || '');
  }

  dismissModal(action) {

    if (action === 'Confirm' && this.isValueRequired === true && this.generalService.isNullOrEmpty(this.value)) {

      this.validator['value'] = {
        error_message: 'Value is required'
      }

      return
    }

    this.modalCtrl.dismiss({
      action: action,
      value: this.value
    })
  }


}
